import { createFileRoute, redirect } from '@tanstack/react-router';
import { AuthenticatedSurfaceLayout } from '@/components/authenticated/AuthenticatedSurfaceLayout';

// Layout route "pathless" para todas las páginas que requieren auth. Cualquier subruta
// con prefijo `_authenticated.*` se renderiza adentro de <AppLayout>.

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/login',
        search: { redirect: location.pathname },
      });
    }
  },
  component: AuthenticatedSurfaceLayout,
});
